const memberList = () => import('@/pages/member/list/index.vue');
const memberForm = () => import('@/pages/member/list/form.vue');
const memberDetail = () => import('@/pages/member/list/detail.vue');

export default [{
    path: '/member/list',
    component: memberList,
    meta: [{
        name: '会员管理',
		activeRoute: '/member/manage'
    },
    {
        name: '会员列表',
        activeRoute: '/member/list'
    }]
},{
    path: '/member/detail',
    component: memberDetail,
    meta: [{
        name: '会员管理',
		activeRoute: '/member/manage'
    },
    {
        name: '会员列表',
        url: '/member/list'
    },
    {
        name: '会员详情',
        activeRoute: '/member/list'
    }]
},{
    path: '/member/form',
    component: memberForm,
    meta: [{
        name: '会员管理',
		activeRoute: '/member/manage'
    },
    {
        name: '会员列表',
        url: '/member/list'
    },
    {
        name: '新增/编辑',
        activeRoute: '/member/list'
    }]
}];